import { useEffect } from "react";
import connectWebSocket from "../WebSocketClient";
import { useAxiosGet } from "./useAxiosGet";
import { useCallback } from "react";

export const useInscriptionsQuery = ({ url, params, enabled = true }) => {

    const { data, setData, loading } = useAxiosGet(url, params, { enabled });

    const updateCompany = useCallback((companyId, changes) => {
        setData(prev => {
            if (!prev) return prev;

            return prev.map(item =>
                item.empresaPerfilFullView.id === companyId
                    ? {
                        ...item,
                        empresaPerfilFullView: {
                            ...item.empresaPerfilFullView,
                            ...changes
                        }
                    }
                    : item
            );
        });
    }, [setData]);

    const updateInscription = (inscriptionId, changes) => {

        setData(prev => {
            if (!prev) return prev;

            return prev.map(item =>
                item.inscripcionView.id === inscriptionId
                    ? {
                        ...item,
                        inscripcionView: {
                            ...item.inscripcionView,
                            ...changes
                        }
                    }
                    : item
            );
        });
    };

    useEffect(() => {
        const clientAttendance = connectWebSocket('inscripciones', (dato) => {
            updateInscription(dato.id, { asistio: dato.asistio });
        });
        return () => {
            clientAttendance?.deactivate?.();
        };
    }, [url, params])

    return {
        companies: data ?? [],
        loading,
        updateCompany,
        updateInscription
    };
};